// extracted by mini-css-extract-plugin
export var container = "_ef-0";
export var content = "_ef-3";
export var customerTitle = "_ef-4";
export var empty = "_ef-5";
export var gray = "_ef-6";
export var header = "_ef-7";
export var info = "_ef-8";
export var loading = "_ef-2";
export var loadingCard = "_ef-9";
export var oneLine = "_ef-a";
export var personName = "_ef-e";
export var pillContainer = "_ef-b";
export var selected = "_ef-1";
export var text = "_ef-c";
export var twoLines = "_ef-d";
export var unread = "_ef-f";
export var unreadIndicator = "_ef-g";